export const INDUSTRY_PLACEHOLDER = "__industry__";
export function getQuestion(def, id) {
    return def.questions.find((q) => q.id === id);
}
export function resolveQuestion(def, id) {
    if (id === def.areaQuestion.id)
        return { kind: "area", area: def.areaQuestion };
    const q = getQuestion(def, id);
    return q ? { kind: "question", question: q } : undefined;
}
/** showIf 評価: 指定した先行設問のいずれかに、指定選択肢が含まれていれば true */
export function isShown(q, answers) {
    if (q.disabled)
        return false;
    if (!q.showIf)
        return true;
    for (const [depId, wanted] of Object.entries(q.showIf)) {
        const given = answers[depId] ?? [];
        if (!wanted.some((w) => given.includes(w)))
            return false;
    }
    return true;
}
/** Q5で選ばれた領域ブロックを、areaQuestionの定義順（A→F）で返す — 設計書 §3 */
export function selectedBlocks(def, answers) {
    const chosen = new Set(answers[def.areaQuestion.id] ?? []);
    return def.areaQuestion.options
        .filter((o) => chosen.has(o.id))
        .map((o) => o.block);
}
function industryQuestionId(def, answers) {
    const q1 = (answers["Q1"] ?? [])[0];
    if (!q1)
        return undefined;
    return def.industryMap[q1];
}
/**
 * 現在の回答に基づき、表示すべき設問IDを順序どおりに列挙する。
 * 回答が進むほどリストは伸びる（Q5選択→ブロック追加、Q4/Q1→条件付き設問追加）。
 * showIf・disabled で非表示になる設問は含めない。
 * — 設計書 §1 分岐構造 全体図に対応
 */
export function visibleQuestionIds(def, answers) {
    const ids = [];
    // STEP1 + STEP2（Q1..Q5 固定順）
    for (const id of def.fixedOrder) {
        if (id === def.areaQuestion.id) {
            ids.push(id);
            continue;
        }
        const q = getQuestion(def, id);
        if (q && isShown(q, answers))
            ids.push(id);
    }
    // STEP3 領域別ブロック（選択された領域のみ、A→F順）
    for (const blockId of selectedBlocks(def, answers)) {
        const block = def.blocks[blockId];
        if (!block)
            continue;
        for (const qid of block.questionIds) {
            const q = getQuestion(def, qid);
            if (q && isShown(q, answers))
                ids.push(qid);
        }
    }
    // STEP4 条件付き追加設問（G1/G2/業種別H）
    for (const entry of def.conditionalOrder) {
        if (entry === INDUSTRY_PLACEHOLDER) {
            const hid = industryQuestionId(def, answers);
            if (hid) {
                const q = getQuestion(def, hid);
                if (q && isShown(q, answers))
                    ids.push(hid);
            }
            continue;
        }
        const q = getQuestion(def, entry);
        if (q && isShown(q, answers))
            ids.push(entry);
    }
    return ids;
}
function isAnswered(answers, id) {
    const a = answers[id];
    return Array.isArray(a) && a.length > 0;
}
/**
 * 次に表示する設問ID。全て回答済みなら null（＝結果表示へ）。— 仕様書 §5 nextQuestion
 * 診断SPA・プレビュー・submitDiagnosis の三者が同一実装を使う。
 */
export function nextQuestion(def, answers) {
    const plan = visibleQuestionIds(def, answers);
    for (const id of plan) {
        if (!isAnswered(answers, id))
            return id;
    }
    return null;
}
/** 進捗（回答済み/表示予定）。分岐で総数が動くため近似値。 */
export function progress(def, answers) {
    const plan = visibleQuestionIds(def, answers);
    const answered = plan.filter((id) => isAnswered(answers, id)).length;
    return { answered, total: plan.length };
}
//# sourceMappingURL=engine.js.map